export const equipment = {
  seo: {
    title: '機材レンタル | LensBank プロ撮影機材',
    description:
      'カメラ、レンズ、照明、録音、モニター、スタビライザーなど、1,000点以上のプロ撮影機材レンタル。多ブランド選択、柔軟なレンタル期間、専門技術サポート。',
    keywords: '機材レンタル,カメラレンタル,レンズレンタル,照明機材,録音設備,撮影機材'
  },
  hero: {
    title: 'プロ機材レンタル',
    subtitle: '1,000点以上のプロ撮影機材、すべての撮影ニーズに対応'
  },
  categories: {
    title: '機材カテゴリー',
    all: 'すべて',
    camera: 'カメラ',
    lens: 'レンズ',
    lighting: '照明',
    audio: '録音',
    monitor: 'モニター',
    stabilizer: 'スタビライザー',
    grip: '三脚・アクセサリー',
    accessories: 'その他アクセサリー'
  },
  subcategories: {
    all: 'すべて',
    cinema: 'シネマカメラ',
    mirrorless: 'ミラーレス',
    camcorder: 'ビデオカメラ',
    action: 'アクションカメラ',
    prime: '単焦点レンズ',
    zoom: 'ズームレンズ',
    led: 'LEDライト',
    hmi: 'HMIライト',
    shotgun: 'ショットガンマイク',
    wireless: 'ワイヤレスマイク',
    production: 'プロダクションモニター',
    gimbal: 'ジンバル'
  },
  filters: {
    title: 'フィルター',
    category: 'カテゴリー',
    subcategory: 'サブカテゴリー',
    brand: 'ブランド',
    allBrands: 'すべてのブランド',
    location: 'レンタル可能店舗',
    priceRange: '価格帯',
    availability: 'レンタル状況',
    available: 'レンタル可能',
    unavailable: 'レンタル中',
    all: 'すべて',
    reset: 'リセット',
    results: '件の結果',
    sortBy: '並び替え',
    sortDefault: 'デフォルト',
    sortPriceLow: '価格が安い順',
    sortPriceHigh: '価格が高い順',
    sortName: '名前順'
  },
  list: {
    perDay: '/日',
    perWeek: '/週',
    viewDetails: '詳細を見る',
    addToCart: '予約に追加',
    outOfStock: 'レンタル中',
    inStock: 'レンタル可能',
    dailyRate: '日貸し',
    available: '利用可能',
    selectCategory: '機材カテゴリーを選択',
    selectCategoryDesc:
      '上部のカテゴリーバーから必要な機材タイプを選択すると、レンタル可能な機材を閲覧できます。',
    noProducts: 'このカテゴリーには機材がありません',
    noProductsDesc: '他のカテゴリーやフィルターをお試しください',
    deposit: '保証金'
  },
  tags: {
    // Canonical machine keys only
    hot: '人気',
    new: '新着',
    incoming: '入荷予定',
    staff_required: 'スタッフ操作必要',
    crew_only: 'クルー限定',
    featured: 'おすすめ'
  },
  detail: {
    specifications: '仕様情報',
    pricing: 'レンタル料金',
    dailyRate: '日貸し',
    weeklyRate: '週貸し',
    monthlyRate: '月貸し',
    deposit: '保証金',
    requirements: 'レンタル要件',
    requirementsText: '身分証明書とクレジットカードが必要です。法人の場合は営業登記証が必要です。',
    notes: '注意事項',
    notesText:
      'レンタル機材は約束の時間内にご返却ください。延滞料金が発生します。機材の破損は実費負担となります。',
    quantity: '数量',
    rentalPeriod: 'レンタル期間',
    startDate: '受取日',
    endDate: '返却日',
    pickupLocation: '受取店舗',
    selectLocation: '店舗を選択',
    addToBooking: '予約カートに追加',
    bookNow: '今すぐ予約',
    available: 'レンタル可能',
    unavailable: 'レンタル中',
    backToList: 'リストに戻る',
    booking: '予約する',
    days: '日',
    stock: '在庫',
    units: '台',
    totalEstimate: '見積もり金額',
    addToCart: '予約カートに追加',
    backToProducts: '機材リストに戻る',
    noWeeklyPrice: '週貸し割引なし',
    stockByLocation: '各店舗在庫'
  },
  related: {
    title: '関連おすすめ機材',
    subtitle: 'こちらもおすすめ',
    viewAll: 'もっと見る',
    noRelated: '関連機材はありません'
  },
  booking: {
    title: '予約カート',
    empty: '予約カートは空です',
    item: '項目',
    quantity: '数量',
    period: 'レンタル期間',
    price: '金額',
    total: '合計',
    remove: '削除',
    clear: 'クリア',
    checkout: '予約を送信',
    continueBooking: '買い物を続ける'
  }
};
